import styled from "styled-components";

export const NewsListingStyles = styled.div`
  min-height: 100vh;

  &.is-visible {
    .animate {
      opacity: 1 !important;
      top: 0 !important;
    }
  }

  .news-listing-container {
    text-align: left;
    width: 100%;
    max-width: 880px;
    padding: 79px 0;
    margin: auto;
    font-size: 18px;

    @media only screen and (max-width: 1079px) {
      padding: 79px 50px 0 50px;
    }

    @media only screen and (max-width: 767px) {
      padding: 70px 20px 0;
    }

    .intro {
      h1 {
        color: #1f00b7;
        position: relative;
        opacity: 0;
        top: 100px;
        transition: 1s ease all;
        font-size: 100px;
        font-weight: 300;
        line-height: 120px;
        text-align: center;
        margin-top: 0;
        margin-bottom: 27px;

        @media only screen and (max-width: 1439px) {
          font-size: 80px;
          line-height: 80px;
        }

        @media only screen and (max-width: 767px) {
          font-size: 50px;
          line-height: 50px;
          margin-bottom: 22px;
        }
      }

      .copy {
        position: relative;
        opacity: 0;
        top: 100px;
        transition: 1s ease all;
        transition-delay: 0.5s;
        font-family: Tiempo;
        font-size: 25px;
        font-weight: 400;
        line-height: 35px;
        text-align: center;
        margin: 0 auto;
        width: 954px;
        margin-bottom: 140px;

        @media only screen and (max-width: 1439px) {
          font-size: 22px;
          line-height: 30px;
        }
        @media only screen and (max-width: 1079px) {
          max-width: 100%;
          width: 760px;
        }

        @media only screen and (max-width: 767px) {
          font-size: 18px;
        }

        p {
          margin: 0;
          padding-bottom: 15px;
        }
      }
    }

    .news-item {
      position: relative;
      max-width: 100%;
      width: 894px;
      display: flex;
      justify-content: space-between;
      margin: auto;
      opacity: 0;
      top: 100px;
      transition: 1s ease all;
      transition-delay: 0.5s;

      .text {
        width: 742px;
        padding-bottom: 50px;
        margin-bottom: 50px;
        border-bottom: 1px solid #000;

        &.clickable {
          cursor: pointer;

          &:hover {
            h2 {
              text-decoration: underline;
            }
          }
        }
      }

      &:last-of-type {
        .text {
          padding-bottom: 0;
          border: 0;
        }
      }
      
      h2 {
        font-size: 32px;
        font-weight: 500;
        line-height: 39px;
        margin-top: 0;
        margin-bottom: 14px;
      }

      .excerpt {
        font-size: 18px;
        line-height: 28.8px;
        font-family: Tiempo;

        p:last-of-type {
          margin-bottom: 0;
        }
      }

      .date {
        padding-top: 10px;
        font-family: Moderat;
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
      }

      @media only screen and (max-width: 1439px) {
        width: 760px;

        .text {
          width: 630px;
          padding-bottom: 40px;
          margin-bottom: 40px;

          h2 {
            font-size: 30px;
            line-height: 36px;
          }
          .excerpt {
            font-size: 17px;
            line-height: 27.2px;
          }
        }
      }
      @media only screen and (max-width: 1079px) {
        width: 728px;

        .text {
          width: 603px;
        }
      }

      @media only screen and (max-width: 767px) {
        width: 100%;
        display: block;

        .date {
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 17px;
        }

        .text {
          width: 100%;
          h2 {
            font-size: 29px;
            line-height: 34px;
            margin-bottom: 25px;
          }
          .excerpt {
            font-size: 15px;
            line-height: 23px;
          }
        }
      }
    }
  }
`;
